import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext({ content: {}, loading: true, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(data || {});
    } catch (e) {
      setContent({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

// Dotted-path getter: c("hero.title", "default")
export const useContent = () => {
  const { content } = useContext(ContentContext);
  return (path, fallback = "") => {
    if (!path) return fallback;
    const parts = path.split(".");
    let cur = content;
    for (const p of parts) {
      if (cur == null || typeof cur !== "object") return fallback;
      cur = cur[p];
    }
    if (cur === undefined || cur === null || cur === "") return fallback;
    return cur;
  };
};

export const useContentActions = () => useContext(ContentContext);
export default ContentContext;
